export default __webpack_public_path__ + "static/media/preset_aged_photo.8313108d.jpg";